import { render, staticRenderFns } from "./CNICPromosExpired.vue?vue&type=template&id=457290a1"
import script from "./CNICPromosExpired.vue?vue&type=script&lang=js"
export * from "./CNICPromosExpired.vue?vue&type=script&lang=js"
import style0 from "./CNICPromosExpired.vue?vue&type=style&index=0&id=457290a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports